export interface NewsItem {
  id: string;
  title: string;
  date: string;
  category: string;
  cover: string;
  summary: string;
  content: string[];
}

export const newsCategories = ["全部", "公司动态", "行业资讯", "项目进展", "荣誉奖项"];

export const news: NewsItem[] = [
  {
    id: "1",
    title: "芒果传媒荣获年度「最具影响力内容制作机构」称号",
    date: "2025-09-28",
    category: "荣誉奖项",
    cover: "https://readdy.ai/api/search-image?query=Award%20ceremony%20stage%20with%20warm%20golden%20lighting%20and%20trophy%2C%20elegant%20professional%20atmosphere%2C%20cinematic%20still%2C%20no%20text&width=900&height=560&seq=mango-news-01&orientation=landscape",
    summary: "在年度行业评选中，芒果传媒凭借多部优质作品与稳定的制作能力，获评年度最具影响力内容制作机构。",
    content: [
      "近日，年度影视行业评选结果正式揭晓，芒果传媒凭借在过去一年中的持续产出与稳定口碑，荣获「年度最具影响力内容制作机构」称号。",
      "评委会在颁奖词中提到，芒果传媒在剧集、综艺、广告等多个内容赛道均保持了高水准的制作质量，并持续探索题材与形式的创新，是行业内颇具代表性的综合型内容机构。",
      "芒果传媒相关负责人表示，这份荣誉属于每一位参与创作的同仁与合作伙伴。未来公司将继续坚持以内容为本，打磨更多有温度、有品质的作品。",
    ],
  },
  {
    id: "2",
    title: "年度大剧《山海之间》正式开机，实景拍摄跨越三省",
    date: "2025-09-15",
    category: "项目进展",
    cover: "https://readdy.ai/api/search-image?query=Film%20production%20opening%20ceremony%20with%20crew%20and%20cameras%20on%20set%2C%20warm%20daylight%2C%20professional%20production%20still%2C%20no%20text&width=900&height=560&seq=mango-news-02&orientation=landscape",
    summary: "备受期待的年度大剧《山海之间》在沿海取景地正式开机，主创团队悉数亮相。",
    content: [
      "由芒果传媒出品制作的年度大剧《山海之间》日前正式开机。该剧以东南沿海渔港为背景，讲述一个家族三代人的时代故事。",
      "据介绍，剧组将在三个省份进行为期数月的实景拍摄，并动用专业水下摄影与航拍团队，力求真实还原海洋场景。",
      "导演林承宇在开机仪式上表示，希望能用镜头记录下普通人的坚韧与温情，让观众在故事中看到生活的力量。",
    ],
  },
  {
    id: "3",
    title: "芒果传媒发布内容战略：聚焦现实题材与技术创新",
    date: "2025-08-30",
    category: "公司动态",
    cover: "https://readdy.ai/api/search-image?query=Modern%20corporate%20conference%20stage%20with%20warm%20lighting%20and%20audience%2C%20professional%20business%20event%20still%2C%20no%20text&width=900&height=560&seq=mango-news-03&orientation=landscape",
    summary: "在新的内容战略中，芒果传媒明确将现实题材创作与制作技术升级作为未来两大核心方向。",
    content: [
      "芒果传媒正式对外发布新一轮内容战略，明确将在未来三年内持续加大现实题材作品的投入，并同步推进虚拟制作、AI 辅助创作等技术的落地应用。",
      "公司内容负责人表示，现实题材一直是芒果传媒的优势赛道，未来将更加关注普通人的生活与情感，用真实打动观众。",
      "在技术层面，芒果传媒计划建设新的数字化制作基地，为剧集与节目提供更高效的制作支持。",
    ],
  },
  {
    id: "4",
    title: "行业观察：长视频内容进入「品质竞争」新阶段",
    date: "2025-08-12",
    category: "行业资讯",
    cover: "https://readdy.ai/api/search-image?query=Abstract%20data%20and%20media%20visualization%20on%20screens%2C%20warm%20amber%20tones%2C%20modern%20office%20atmosphere%2C%20no%20text&width=900&height=560&seq=mango-news-04&orientation=landscape",
    summary: "随着观众审美提升，长视频行业的竞争重心正从数量转向品质，精品化成为共识。",
    content: [
      "过去几年，长视频行业经历了从规模扩张到存量竞争的转变。如今，越来越多的平台与制作机构意识到，唯有品质才能留住观众。",
      "从内容供给侧看，剧集与节目的平均制作周期在变长，单集投入在提升，行业整体正走向「少而精」。",
      "对于制作机构而言，这既是挑战也是机会——谁能持续稳定地产出优质内容，谁就能在下一阶段占据主动。",
    ],
  },
  {
    id: "5",
    title: "《寻味山海》第二季官宣，将深入更多原产地",
    date: "2025-07-25",
    category: "项目进展",
    cover: "https://readdy.ai/api/search-image?query=Documentary%20filming%20of%20local%20food%20in%20a%20rural%20village%2C%20warm%20daylight%2C%20authentic%20atmosphere%2C%20no%20text&width=900&height=560&seq=mango-news-05&orientation=landscape",
    summary: "口碑美食纪录片综艺《寻味山海》正式官宣第二季，将走访更多地域与原产地。",
    content: [
      "凭借真实治愈的风格，《寻味山海》第一季收获了广泛好评。日前，节目组正式官宣第二季启动。",
      "新一季将继续深入食材原产地，同时增加更多与当地人的互动，让食物的故事更加立体。",
      "节目将于明年与观众见面，具体播出信息将陆续公布。",
    ],
  },
  {
    id: "6",
    title: "芒果传媒与多家高校达成人才培养合作",
    date: "2025-07-08",
    category: "公司动态",
    cover: "https://readdy.ai/api/search-image?query=Students%20and%20mentors%20in%20a%20modern%20media%20workshop%2C%20warm%20natural%20light%2C%20collaborative%20atmosphere%2C%20no%20text&width=900&height=560&seq=mango-news-06&orientation=landscape",
    summary: "芒果传媒宣布与多所高校建立合作，共同探索影视传媒人才的联合培养模式。",
    content: [
      "为夯实行业人才基础，芒果传媒近日与多所高校签署合作协议，将在实习实训、课程共建、项目孵化等方面展开深度合作。",
      "公司将为优秀学生提供参与真实项目的机会，让学生在实战中成长。",
      "芒果传媒希望通过这样的方式，为行业持续输送新鲜血液。",
    ],
  },
  {
    id: "7",
    title: "《城市脉搏》入围国际电视剧展映单元",
    date: "2025-06-20",
    category: "荣誉奖项",
    cover: "https://readdy.ai/api/search-image?query=International%20film%20festival%20red%20carpet%20scene%20at%20dusk%2C%20warm%20elegant%20lighting%2C%20cinematic%20still%2C%20no%20text&width=900&height=560&seq=mango-news-07&orientation=landscape",
    summary: "芒果传媒出品的都市悬疑剧《城市脉搏》成功入围国际电视剧展映单元。",
    content: [
      "近日，都市悬疑剧《城市脉搏》传来好消息，该剧成功入围国际电视剧展映单元，将面向海外观众展映。",
      "该剧以多线叙事和电影级制作获得关注，被认为是国产都市题材的一次有益探索。",
      "主创团队表示，期待通过作品让更多海外观众了解中国当代都市的面貌。",
    ],
  },
  {
    id: "8",
    title: "芒果传媒举办年度创作者交流大会",
    date: "2025-06-05",
    category: "公司动态",
    cover: "https://readdy.ai/api/search-image?query=Creative%20industry%20networking%20event%20with%20people%20discussing%2C%20warm%20modern%20venue%20lighting%2C%20no%20text&width=900&height=560&seq=mango-news-08&orientation=landscape",
    summary: "来自创作一线的导演、编剧、制片人齐聚一堂，分享经验、碰撞灵感。",
    content: [
      "芒果传媒年度创作者交流大会近日举行，数十位来自创作一线的导演、编剧、制片人与技术团队代表参加。",
      "大会围绕现实题材创作、剧本打磨、技术创新等议题展开深入讨论。",
      "公司表示，将持续搭建这样的交流平台，让创作者的声音被更好地听见。",
    ],
  },
];